import React, { useState } from 'react';
import './topBar.css';
import { Link } from 'react-router-dom';

export default function TopBar({ userName = 'Jana Mahmoud', role = 'Administrator' }) {
  const [search, setSearch] = useState('');

  return (
    <header className="topbar">
      <div className="topbar-search-wrap">
        <span className="topbar-search-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8"/>
            <path d="M20 20l-3-3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
          </svg>
        </span>
        <input
          className="topbar-search"
          type="text"
          placeholder="Search..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div className="topbar-right">
      <Link to="/AccessDenied">
        <button className="topbar-icon-btn" aria-label="Notifications">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M18 8a6 6 0 00-12 0c0 7-3 9-3 9h18s-3-2-3-9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.73 21a2 2 0 01-3.46 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
          </svg>
          <span className="topbar-badge" />
        </button>
      </Link>

        <div className="topbar-divider" />

        <div className="topbar-user">
          <div className="topbar-user-info">
            <span className="topbar-user-name">{userName}</span>
            <span className="topbar-user-role">{role}</span>
          </div>
          <div className="topbar-avatar">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="8" r="4" fill="currentColor" opacity="0.8"/>
              <path d="M4 20c0-4 3.58-7 8-7s8 3 8 7" fill="currentColor" opacity="0.5"/>
            </svg>
          </div>
        </div>
      </div>
    </header>
  );
}